import { render, staticRenderFns } from "./CatalogItemIcon.vue?vue&type=template&id=1451777a&scoped=true&"
import script from "./CatalogItemIcon.vue?vue&type=script&lang=ts&"
export * from "./CatalogItemIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogItemIcon.vue?vue&type=style&index=0&id=1451777a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451777a",
  null
  
)

export default component.exports